export default __webpack_public_path__ + "static/media/hmgoepprod 1.55b29595.png";